//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";
import { M, MMinus, MPlus, T } from "../../../utils/MT";

// component
import MyInquiryList from "./components/MyInquiryList";
import DefaultModal from "../../../component/popup/DefaultModal";
import BasicBtn from "../../../component/button/BasicBtn";

export default function MyInquiryListPage() {
    const [delModal, setDelModal] = useState(false); // 경고 모달
    const [delCompleteModal, setDelCompleteModal] = useState(false);

    // 1. 문의 삭제 팝업
    const delContent = () => {
        return (
            <ModalBox>
                <ConTitle>문의를 삭제하시겠습니까?</ConTitle>
                <BtnSmallWrap>
                    <BasicBtn text="취소" gray={true} black={true} onClick={() => setDelModal(false)} />
                    <BasicBtn text="문의 삭제" onClick={clickEvent} />
                </BtnSmallWrap>
            </ModalBox>
        );
    };

    const clickEvent = () => {
        setDelModal(false);
        setDelCompleteModal(true);
    };

    return (
        <>
            <MyInquiryList setDelModal={setDelModal} />
            {/* 1. 문의 삭제 팝업 */}
            {delModal && <DefaultModal closeModal={() => setDelModal(false)} contents={delContent} />}
            {/* 2. 문의 삭제 완료 팝업 */}
            {delCompleteModal && <DefaultModal closeModal={() => setDelCompleteModal(false)} Simple={true} text="문의가 삭제되었습니다." />}
        </>
    );
}

// 팝업 스타일링
const ModalBox = styled.div`
    width: calc(100vw * (450 / 1920));

    text-align: center;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (450 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(340)};
    }
`;
const ConTitle = styled.div`
    font-size: calc(100vw * (15 / 1920));

    margin-bottom: calc(100vw * (30 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-bottom: calc(100vw * (30 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};

        margin-bottom: ${M(20)};
    }
`;

const BtnSmallWrap = styled.div`
    display: flex;
    align-items: center;

    width: calc(100vw * (380 / 1920));
    margin: 0 auto;

    & > p:first-child {
        margin-right: calc(100vw * (20 / 1920));
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (380 / 1300));

        & > p:first-child {
            margin-right: calc(100vw * (20 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(340)};

        & > p:first-child {
            margin-right: ${M(20)};
        }
    }
`;
